module.exports = __webpack_public_path__ + "img/section7.74777d1c.png";